<template>
	<svg
		width="18px"
		height="12px"
		viewBox="0 0 18 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-93.000000, -345.000000)" fill="#FFFFFF">
				<g transform="translate(93.000000, 345.000000)">
					<path
						d="M9,12 C8.5023,12 8.1,11.6168571 8.1,11.1428571 L8.1,0.857142857 C8.1,0.384 8.5023,0 9,0 C9.4977,0 9.9,0.384 9.9,0.857142857 L9.9,11.1428571 C9.9,11.6168571 9.4977,12 9,12"
					></path>
					<path
						d="M12.6,12 C12.1023,12 11.7,11.6168571 11.7,11.1428571 L11.7,0.857142857 C11.7,0.384 12.1023,0 12.6,0 L17.1,0 C17.5977,0 18,0.384 18,0.857142857 C18,1.33028571 17.5977,1.71428571 17.1,1.71428571 L13.5,1.71428571 L13.5,11.1428571 C13.5,11.6168571 13.0977,12 12.6,12"
					></path>
					<path
						d="M16.2,7.38461538 L12.6,7.38461538 C12.1023,7.38461538 11.7,6.97107692 11.7,6.46153846 C11.7,5.952 12.1023,5.53846154 12.6,5.53846154 L16.2,5.53846154 C16.6977,5.53846154 17.1,5.952 17.1,6.46153846 C17.1,6.97107692 16.6977,7.38461538 16.2,7.38461538"
					></path>
					<path
						d="M3.9375,12 L2.3625,12 C1.059975,12 0,10.8462857 0,9.42857143 L0,2.57142857 C0,1.15371429 1.059975,0 2.3625,0 L3.9375,0 C5.240025,0 6.3,1.15371429 6.3,2.57142857 C6.3,3.04457143 5.9472,3.42857143 5.5125,3.42857143 C5.0778,3.42857143 4.725,3.04457143 4.725,2.57142857 C4.725,2.09914286 4.3714125,1.71428571 3.9375,1.71428571 L2.3625,1.71428571 C1.9285875,1.71428571 1.575,2.09914286 1.575,2.57142857 L1.575,9.42857143 C1.575,9.90171429 1.9285875,10.2857143 2.3625,10.2857143 L3.9375,10.2857143 C4.3714125,10.2857143 4.725,9.90171429 4.725,9.42857143 L4.725,6.85714286 L3.9375,6.85714286 C3.5028,6.85714286 3.15,6.47314286 3.15,6 C3.15,5.52685714 3.5028,5.14285714 3.9375,5.14285714 L5.5125,5.14285714 C5.9472,5.14285714 6.3,5.52685714 6.3,6 L6.3,9.42857143 C6.3,10.8462857 5.240025,12 3.9375,12"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'GifTextIcon',
}
</script>

<style lang="scss" scoped></style>
